import React, { useState } from "react";
import PropTypes from "prop-types";
import AutocompleteLocation from "../../autocomplete/location";
import autosuggestionCss from "../../../css/agents/autosuggestion.module.css";
import axiosResiInstance from "../../../http/axiosResi";

const getLocation = async (value) => {
    const locations = await axiosResiInstance.get("/autocomplete", {
        params: {
            q: value,
        },
    });

    return locations.data[0];
};

const Location = (props) => {
    const [isChanged, setIsChanged] = useState(false);

    const handleChange = (locationText, location) => {
        if (location === undefined || !location) {
            setIsChanged(true);

            return false;
        }

        let fieldValue = props.value;

        fieldValue.value = location;
        fieldValue.label = location.label;

        props.onChange(fieldValue);
    };

    const handleBlur = async (event) => {
        if (!event.target) {
            return event;
        }

        if (isChanged) {
            return event;
        }

        const target = event.target;
        const value = target.value;

        const location = await getLocation(value);

        if (!location) {
            return event;
        }

        let fieldValue = props.value;

        fieldValue.value = location;
        fieldValue.label = location.label;

        props.onChange(fieldValue);
    };

    const { value } = props;
    let fieldValue = value.value || "";

    if (typeof fieldValue !== "string") {
        fieldValue = fieldValue.label;
    }

    return (
        <AutocompleteLocation
            id="select-agent-search"
            locationTypes="zip,city,state"
            placeholder="Search city, zip or state"
            onChange={handleChange}
            onBlur={handleBlur}
            theme={autosuggestionCss}
            value={fieldValue}
            required
        />
    );
};

Location.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default Location;
